import { FacilityInvoiceDetail, InvoiceStatus } from '../models';

export const mockInvoices: FacilityInvoiceDetail[] = [
  {
    createdAt: '2025-01-05T10:00:00Z',
    updatedAt: '2025-01-06T12:00:00Z',
    id: 'inv-001',
    facilityId: 'fac-101',
    facilityName: 'Green Valley Care Center',
    invoiceNumber: 'INV-2025-001',
    invoiceDate: '2025-01-01',
    dueDate: '2025-01-15',
    totalAmount: 4200,
    paidAmount: 2000,
    remainingBalance: 2200,
    status: InvoiceStatus.PARTIALLY_PAID,
    isOverdue: false,
    daysOverdue: 0,
    timesheetsCount: 3,
    periodStartDate: '2024-12-15',
    periodEndDate: '2024-12-31',
    paidDate: '',
    payPeriodFormatted: 'Dec 15–31, 2024',
    totalHoursScheduled: 120,
    totalHoursWorked: 112,
    description: 'Nursing staff coverage for the second half of December.',
    lineItems: [
      {
        createdAt: '2025-01-05T10:00:00Z',
        updatedAt: '2025-01-05T10:00:00Z',
        id: 'li-001',
        description: 'RN Shift Coverage',
        quantity: 40,
        unitPrice: 50,
        totalAmount: 2000,
        shiftDate: '2024-12-20',
        startTime: '08:00',
        endTime: '16:00'
      },
      {
        createdAt: '2025-01-05T10:00:00Z',
        updatedAt: '2025-01-05T10:00:00Z',
        id: 'li-002',
        description: 'CNA Shift Coverage',
        quantity: 72,
        unitPrice: 30,
        totalAmount: 2160,
        shiftDate: '2024-12-22',
        startTime: '07:00',
        endTime: '19:00'
      }
    ],
    payments: [
      {
        createdAt: '2025-01-06T12:00:00Z',
        updatedAt: '2025-01-06T12:00:00Z',
        id: 'pay-001',
        invoiceId: 'inv-001',
        amount: 2000,
        paymentMethod: 'ACH',
        referenceNumber: 'BT-784512',
        paymentDate: '2025-01-06',
        notes: 'Initial partial payment',
        recordedByUserId: 'user-55',
        recordedByUserName: 'Laura Smith'
      }
    ],
    timesheets: [
      {
        timesheetId: 'ts-001',
        contractorId: 'c-348',
        contractorName: 'Julie Hansen',
        weekStartDate: '2024-12-15',
        weekEndDate: '2024-12-21',
        totalHours: 36,
        totalAmount: 1800,
        status: 'Approved'
      },
      {
        timesheetId: 'ts-002',
        contractorId: 'c-349',
        contractorName: 'Mark Liu',
        weekStartDate: '2024-12-22',
        weekEndDate: '2024-12-28',
        totalHours: 40,
        totalAmount: 1400,
        status: 'Approved'
      },
      {
        timesheetId: 'ts-003',
        contractorId: 'c-350',
        contractorName: 'Ana Rivera',
        weekStartDate: '2024-12-29',
        weekEndDate: '2024-12-31',
        totalHours: 36,
        totalAmount: 1000,
        status: 'Approved'
      }
    ]
  },

  {
    createdAt: '2025-02-01T09:00:00Z',
    updatedAt: '2025-02-02T08:00:00Z',
    id: 'inv-002',
    facilityId: 'fac-102',
    facilityName: 'Sunrise Medical Center',
    invoiceNumber: 'INV-2025-017',
    invoiceDate: '2025-01-25',
    dueDate: '2025-02-05',
    totalAmount: 3000,
    paidAmount: 3000,
    remainingBalance: 0,
    status: InvoiceStatus.PAID,
    isOverdue: false,
    daysOverdue: 0,
    timesheetsCount: 2,
    periodStartDate: '2025-01-01',
    periodEndDate: '2025-01-15',
    paidDate: '2025-02-02',
    payPeriodFormatted: 'Jan 1–15, 2025',
    totalHoursScheduled: 80,
    totalHoursWorked: 78,
    description: 'Mid-January staffing coverage.',
    lineItems: [
      {
        createdAt: '2025-02-01T09:00:00Z',
        updatedAt: '2025-02-01T09:00:00Z',
        id: 'li-010',
        description: 'LPN Day Shifts',
        quantity: 50,
        unitPrice: 40,
        totalAmount: 2000,
        shiftDate: '2025-01-10',
        startTime: '08:00',
        endTime: '16:00'
      },
      {
        createdAt: '2025-02-01T09:00:00Z',
        updatedAt: '2025-02-01T09:00:00Z',
        id: 'li-011',
        description: 'CNA Evenings',
        quantity: 28,
        unitPrice: 35,
        totalAmount: 980,
        shiftDate: '2025-01-12',
        startTime: '16:00',
        endTime: '23:00'
      }
    ],
    payments: [
      {
        createdAt: '2025-02-02T08:00:00Z',
        updatedAt: '2025-02-02T08:00:00Z',
        id: 'pay-010',
        invoiceId: 'inv-002',
        amount: 3000,
        paymentMethod: 'CreditCard',
        referenceNumber: 'CC-993812',
        paymentDate: '2025-02-02',
        notes: 'Full payment',
        recordedByUserId: 'user-10',
        recordedByUserName: 'Daniel Carter'
      }
    ],
    timesheets: [
      {
        timesheetId: 'ts-010',
        contractorId: 'c-400',
        contractorName: 'Lisa Moore',
        weekStartDate: '2025-01-01',
        weekEndDate: '2025-01-07',
        totalHours: 40,
        totalAmount: 1600,
        status: 'Approved'
      },
      {
        timesheetId: 'ts-011',
        contractorId: 'c-401',
        contractorName: 'Samuel Ortiz',
        weekStartDate: '2025-01-08',
        weekEndDate: '2025-01-15',
        totalHours: 38,
        totalAmount: 1400,
        status: 'Approved'
      }
    ]
  },

  {
    createdAt: '2025-02-10T14:00:00Z',
    updatedAt: '2025-02-20T09:00:00Z',
    id: 'inv-003',
    facilityId: 'fac-103',
    facilityName: 'Lakeside Rehabilitation Center',
    invoiceNumber: 'INV-2025-021',
    invoiceDate: '2025-02-01',
    dueDate: '2025-02-10',
    totalAmount: 5150,
    paidAmount: 0,
    remainingBalance: 5150,
    status: InvoiceStatus.OVERDUE,
    isOverdue: true,
    daysOverdue: 10,
    timesheetsCount: 4,
    periodStartDate: '2025-01-16',
    periodEndDate: '2025-01-31',
    paidDate: '',
    payPeriodFormatted: 'Jan 16–31, 2025',
    totalHoursScheduled: 150,
    totalHoursWorked: 148,
    description: 'Second-half January clinical and support staffing.',
    lineItems: [
      {
        createdAt: '2025-02-10T14:00:00Z',
        updatedAt: '2025-02-10T14:00:00Z',
        id: 'li-020',
        description: 'RN Night Shift',
        quantity: 60,
        unitPrice: 55,
        totalAmount: 3300,
        shiftDate: '2025-01-20',
        startTime: '19:00',
        endTime: '07:00'
      },
      {
        createdAt: '2025-02-10T14:00:00Z',
        updatedAt: '2025-02-10T14:00:00Z',
        id: 'li-021',
        description: 'Support Staff',
        quantity: 50,
        unitPrice: 37,
        totalAmount: 1850,
        shiftDate: '2025-01-25',
        startTime: '08:00',
        endTime: '16:00'
      }
    ],
    payments: [],
    timesheets: [
      {
        timesheetId: 'ts-020',
        contractorId: 'c-501',
        contractorName: 'Morgan Lee',
        weekStartDate: '2025-01-16',
        weekEndDate: '2025-01-22',
        totalHours: 37,
        totalAmount: 1500,
        status: 'Approved'
      },
      {
        timesheetId: 'ts-021',
        contractorId: 'c-502',
        contractorName: 'Kara Thompson',
        weekStartDate: '2025-01-16',
        weekEndDate: '2025-01-22',
        totalHours: 38,
        totalAmount: 1300,
        status: 'Approved'
      },
      {
        timesheetId: 'ts-022',
        contractorId: 'c-503',
        contractorName: 'Diego Morales',
        weekStartDate: '2025-01-23',
        weekEndDate: '2025-01-31',
        totalHours: 40,
        totalAmount: 1350,
        status: 'Approved'
      },
      {
        timesheetId: 'ts-023',
        contractorId: 'c-504',
        contractorName: 'Yuki Tan',
        weekStartDate: '2025-01-23',
        weekEndDate: '2025-01-31',
        totalHours: 33,
        totalAmount: 1000,
        status: 'Approved'
      }
    ]
  },

  {
    createdAt: '2025-02-18T11:20:00Z',
    updatedAt: '2025-02-18T11:20:00Z',
    id: 'inv-004',
    facilityId: 'fac-104',
    facilityName: 'Evergreen Senior Living',
    invoiceNumber: 'INV-2025-030',
    invoiceDate: '2025-02-10',
    dueDate: '2025-02-25',
    totalAmount: 2500,
    paidAmount: 0,
    remainingBalance: 2500,
    status: InvoiceStatus.SENT,
    isOverdue: false,
    daysOverdue: 0,
    timesheetsCount: 1,
    periodStartDate: '2025-02-01',
    periodEndDate: '2025-02-10',
    paidDate: '',
    payPeriodFormatted: 'Feb 1–10, 2025',
    totalHoursScheduled: 60,
    totalHoursWorked: 58,
    description: 'Coverage for early February period.',
    lineItems: [
      {
        createdAt: '2025-02-18T11:20:00Z',
        updatedAt: '2025-02-18T11:20:00Z',
        id: 'li-030',
        description: 'CNA Early Morning Shifts',
        quantity: 58,
        unitPrice: 43,
        totalAmount: 2494,
        shiftDate: '2025-02-05',
        startTime: '05:00',
        endTime: '13:00'
      }
    ],
    payments: [],
    timesheets: [
      {
        timesheetId: 'ts-030',
        contractorId: 'c-600',
        contractorName: 'Brenda Scott',
        weekStartDate: '2025-02-01',
        weekEndDate: '2025-02-10',
        totalHours: 58,
        totalAmount: 2500,
        status: 'Submitted'
      }
    ]
  }
];
